// NutritionistDashboard.js

import React, { useState, useEffect } from "react";
import { auth, db } from "./firebase/firebaseConfig";
import { collection, query, where, getDocs } from "firebase/firestore";
import Header from "./components/Header";
import { useTranslation } from "react-i18next";
import NutritionAssessmentTab from "./components/NutritionAssessmentTab";
import NutritionPlanTab from "./components/NutritionPlanTab";
import FoodLogTab from "./components/FoodLogTab";

function NutritionistDashboard({ user }) {
  const { t } = useTranslation();
  const [athletes, setAthletes] = useState([]);
  const [selectedAthlete, setSelectedAthlete] = useState("");
  const [activeTab, setActiveTab] = useState("assessment");

  useEffect(() => {
    const fetchAthletes = async () => {
      const q = query(
        collection(db, "users"),
        where("role", "==", "athlete"),
        where("assignedNutritionist", "==", user?.uid)
      );
      const snapshot = await getDocs(q);
      const results = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setAthletes(results);
    };

    if (user?.uid) fetchAthletes();
  }, [user]);

  return (
    <>
      <Header user={user} />
      <div className="min-h-screen bg-white px-4 py-8">
        <div className="max-w-4xl mx-auto bg-[#f1efe7] rounded-xl shadow-md p-6">
          <h2 className="text-2xl font-bold text-gray-800 mb-6">
            {t("nutritionist_dashboard")}
          </h2>

          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {t("select_athlete")}
            </label>
            <select
              value={selectedAthlete}
              onChange={(e) => setSelectedAthlete(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-md bg-white"
            >
              <option value="">{t("select_athlete")}</option>
              {athletes.map((athlete) => (
                <option key={athlete.id} value={athlete.id}>
                  {athlete.name || athlete.email}
                </option>
              ))}
            </select>
          </div>

          {selectedAthlete && (
            <>
              <nav className="flex border-b">
                {["assessment", "plan", "log"].map((key) => (
                  <button
                    key={key}
                    onClick={() => setActiveTab(key)}
                    className={`px-4 py-2 text-sm font-medium rounded-t-md ${
                      activeTab === key
                        ? "bg-[#b22222] text-white"
                        : "bg-white text-gray-700 border border-gray-300"
                    }`}
                  >
                    {t(`${key}_tab`)}
                  </button>
                ))}
              </nav>

              {activeTab === "assessment" && (
                <NutritionAssessmentTab athleteId={selectedAthlete} />
              )}
              {activeTab === "plan" && (
                <NutritionPlanTab athleteId={selectedAthlete} />
              )}
              {activeTab === "log" && (
                <FoodLogTab athleteId={selectedAthlete} />
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default NutritionistDashboard;
